import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export const Hero = () => {
  const scrollToProducts = () => {
    const element = document.getElementById('products');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      className="relative min-h-screen flex items-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_spice-ball-bakery/artifacts/zs944ynj_IMG_20251206_155151999_HDR~2.jpg"
          alt="Sicilian Chocolate Spice Cookies with glaze"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-overlay"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-32">
        <div className="max-w-2xl">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-sm uppercase tracking-[0.2em] text-[#786C65] mb-4"
          >
            Handcrafted with Love
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-5xl md:text-6xl lg:text-7xl font-heading font-semibold text-[#7B3E19] leading-tight mb-6"
            data-testid="hero-title"
          >
            Sicilian Chocolate
            <br />
            <span className="text-[#2A1A14]">Spice Cookies</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg md:text-xl text-[#2A1A14]/80 leading-relaxed mb-8 max-w-xl"
            data-testid="hero-description"
          >
            Traditional Sicilian recipes passed down through generations. 
            Our chocolate balls are made with premium cocoa, warm spices, 
            and a whole lot of love.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <Button
              onClick={scrollToProducts}
              className="bg-[#7B3E19] hover:bg-[#633113] text-white px-8 py-6 text-lg rounded-sm btn-primary"
              data-testid="hero-shop-button"
            >
              Shop Now
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              variant="outline"
              onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-[#7B3E19] text-[#7B3E19] hover:bg-[#7B3E19] hover:text-white px-8 py-6 text-lg rounded-sm"
              data-testid="hero-story-button"
            >
              My Story
            </Button>
          </motion.div>
        </div>
      </div>

      {/* Decorative scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
      >
        <div className="w-6 h-10 border-2 border-[#7B3E19]/30 rounded-full flex justify-center">
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-1.5 h-3 bg-[#7B3E19]/50 rounded-full mt-2"
          />
        </div>
      </motion.div>
    </section>
  );
};
